export default __webpack_public_path__ + "static/media/AO.a76f7aa8.svg";